// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607010546/js/" + chunkId + "." + {"44":"e0a91d4a","225":"3ee17b7c","481":"87fa7876","486":"2a50f35b","770":"72d6fce1"}[chunkId] + ".0.7847255124859924.chunk.js";
};